import { isAxiosError } from 'axios';

import { getDearDocConnection } from '@/lib/api';
import { getLocationIdFromUrl } from '@/lib/helpers/urlParams';
import { DearDocConnection } from '@/types/api.types';

type FetchConnectionResponse = Promise<{
  error?: string | null;
  connection: DearDocConnection | null;
}>;

export const fetchConnection = async (): FetchConnectionResponse => {
  try {
    const locationId = getLocationIdFromUrl();
    if (!locationId) {
      return {
        error: 'Missing or invalid location, please provide a valid ID in the URL',
        connection: null,
      };
    }
    const res = await getDearDocConnection(locationId);

    return { connection: res.connection, error: null };
  } catch (e) {
    if (isAxiosError(e) && e.response?.status === 404) {
      return {
        error: 'Location not found, please check the URL or contact support',
        connection: null,
      };
    }
    return {
      error: 'Sorry, error occurred fetching the connection data',
      connection: null,
    };
  }
};
